// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_46-6";
export var headerCell = "_46-2";
export var rowWrapper = "_46-4";
export var stickyAggregationCell = "_46-a";
export var stickyAggregationRow = "_46-7";
export var stickyColumnCell = "_46-9";
export var stickyColumnHeaderCell = "_46-8";
export var table = "_46-1";
export var virtualRowWrapper = "_46-5";
export var virtualTableContainer = "_46-0";
export var white = "_46-3";